import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const SkeletonUpdateCard: React.FC = () => {
  return (
    <div className="upates_card placeholder-glow">

      {/* Image Skeleton */}
      <span
        className="placeholder d-block w-100 rounded"
        style={{ height: "180px" }}
      ></span>

      {/* Card Info */}
      <div className="upates_card_info mt-3">

        {/* Update type */}
        <span
          className="placeholder col-4 mb-2 d-block"
          style={{ height: "14px", borderRadius: "4px" }}
        ></span>

        {/* Title */}
        <span
          className="placeholder col-10 d-block mb-2"
          style={{ height: "18px", borderRadius: "6px" }}
        ></span>
        <span
          className="placeholder col-7 d-block mb-3"
          style={{ height: "18px", borderRadius: "6px" }}
        ></span>

        {/* Date */}
        <span
          className="placeholder col-5 d-block"
          style={{ height: "14px", borderRadius: "4px" }}
        ></span>
      </div>
    </div>
  );
};

export default SkeletonUpdateCard;
